import React from 'react';
import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { Provider } from 'react-redux';
import App from './App';
import ToastMessage from './components/ToastMessage/ToastMessage';
import './index.css';
import reportWebVitals from './reportWebVitals';
import store from './store/store';
import './variables.scss';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

function fallbackRender({ error }) {
  return <ToastMessage toast={error.message} hideClose />;
}

root.render(
  <React.StrictMode>
    <ErrorBoundary fallbackRender={fallbackRender}>
      <Provider store={store}>
        <App />
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
